var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center country-list__item"},[_c('img',{attrs:{"alt":_vm.title,"src":'/countries/' + _vm.pic + '.png'}}),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }